import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1120px;
  margin: 50px auto 100px auto;
  padding: 0.5em 1em;
`;

export const ContainerMdal = styled.div`
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  padding: 4em;
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SlideContainer = styled.div`
  @media (max-width: 1024px) {
    width: 800px;
    margin: 0 auto;
  }
`;

export const SlideItem = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  @media (max-width: 1024px) {
    max-width: 800px;
  }
  @media (max-width: 425px) {
    img {
      width: 100%;
    }
  }
  @media (max-width: 320px) {
    img {
      width: 100%;
    }
  }
`;

export const ContainerText = styled.div`
  text-align: center;
  padding: 60px 0 30px 0;
  p,
  strong {
    font-family: 'Inter', sans-serif;
  }
  strong {
    font-weight: bold;
  }
  @media (max-width: 425px) {
    padding: 10px 0 30px 0;

    p {
      font-size: 18px;
    }
  }
`;

//novo css
export const ContentItem = styled.div`
  border-radius: 16px;
`;

export const Content = styled.div`
  margin: 0 auto;

  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 260px;
  height: 50vh;

  padding: 20px;
  border-radius: 16px;

  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const AlignButton = styled.div`
  margin: 0 auto;
  button {
    box-shadow: none;
  }
`;

export const AlignText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 100px;
`;

export const ContentText = styled.div`
  p {
    font-family: 'Inter', sans-serif;
    color: #fff;
    font-size: 26px;
    width: 95%;

    word-wrap: break-word;
    overflow-wrap: break-word;

    @media (max-width: 1024px) {
      font-size: 18px;
      width: 90%;
    }

    @media (max-width: 768px) {
      font-size: 17px;
      width: 90%;
    }

    @media (max-width: 480px) {
      font-size: 15px;
      width: 85%;
    }
  }
  margin-top: auto;
`;

export const RoundButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #000;
  border: none;
  font-weight: bold;
  cursor: pointer;
  p {
    color: #fff;
    font-size: 18px;
  }

  &:before {
    content: none;
  }
  &:hover {
    background-color: #2e2e2e;
  }
`;

export const ContainerMobile = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 1.2em;
  scrollbar-width: none;

  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
